import React from 'react';

interface CopyrightFooterProps {
  variant?: 'dark' | 'light';
  className?: string;
}

export default function CopyrightFooter({ variant = 'dark', className = '' }: CopyrightFooterProps) {
  const isDark = variant === 'dark';

  return (
    <footer
      className={`w-full flex items-center justify-center py-3 px-6 border-t ${className}`}
      style={{
        borderColor: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.08)',
      }}
    >
      <p
        className="text-xs tracking-wide"
        style={{
          color: isDark ? 'rgba(200,210,220,0.55)' : 'rgba(30,50,80,0.45)',
          fontWeight: 400,
          letterSpacing: '0.03em',
        }}
      >
        © 2026 TigaPri Sdn Bhd. All rights reserved.
      </p>
    </footer>
  );
}
